module.exports = __webpack_public_path__ + "img/zip.0eb70220.svg";